/**
 * Copy - Centered, Large module
 *
 * Simple copy module, with centered text.
 */

// Deps
import { createComponent } from "react-fela";
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { fonts } from "~/styleguide/typography";

export default function CopyCentered({ block }) {
    const { copy, anchor_id } = block;

    if (!copy) return null;

    return (
        <Container id={anchor_id} className="module-copy-centered">
            <Copy
                dangerouslySetInnerHTML={{
                    __html: copy
                }}
            />
        </Container>
    );
}

const Container = createComponent(
    () => ({
        textAlign: "center",
        extend: [
            fluid("paddingH", gutters.default),
            fluid("paddingV", gutters.vertical)
        ]
    }),
    "div",
    ["id"]
);

const Copy = createComponent(
    () => ({
        maxWidth: 850,
        marginH: "auto",
        lineHeight: "1.2",
        ...fonts.aeonikRegular,

        extend: [fluid("font-size", { max: 36, min: 24 })]
    }),
    "p",
    ["dangerouslySetInnerHTML"]
);
